module.exports = __webpack_public_path__ + "static/media/03.ac0ced6a.jpg";